import React, { useState, useEffect } from 'react';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import Chat from './Chat';
import Unauthorized from './Unauthorized';
import Home from './Home';
import './App.css';

// Whitelist of authorized emails
const AUTHORIZED_EMAILS = [
  'alexr314@gmail.com',
  'jakemroman@gmail.com',
  'orchestral.dev@gmail.com'
];

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return unsubscribe;
  }, []);

  if (user) {
    // User is signed in, check if they're authorized
    const userEmail = user.email;
    const isAuthorized = AUTHORIZED_EMAILS.includes(userEmail);

    if (isAuthorized) {
      // User is authorized, show the chat interface
      return <Chat user={user} />;
    } else {
      // User is not authorized, show the unauthorized page
      return <Unauthorized />;
    }
  } else {
    // User is not signed in, show the landing page
    return <Home />;
  }
}

export default App;